import dayjs from "dayjs";
import React, { useContext } from "react";
import GlobalContext from "../context/GlobalContext";
import {useNavigate} from 'react-router-dom'

export default function CalendarHeader() {

  const history = useNavigate();

  const { monthIndex, setMonthIndex, setShowWeekTab } = useContext(GlobalContext);
  function handlePrevMonth() {
    setMonthIndex(monthIndex - 1);
  }
  function handleNextMonth() {
    setMonthIndex(monthIndex + 1);
  }
  function handleReset() {
    setMonthIndex(
      monthIndex === dayjs().month()
        ? monthIndex + Math.random()
        : dayjs().month()
    );
  }

  function handleChangeToMonth(){
    setShowWeekTab(false)
  }

  function handleChangeToWeek(){
    setShowWeekTab(true)
  }

  return (
    <header className="flex-rows-center-spaceBtw">
      <div className="px-4 py-2 flex items-center">
        <button onClick={handleReset} className="border rounded py-2 px-4 mr-5">
          Today
        </button>
        <button onClick={handlePrevMonth}>
          <span className="material-icons-outlined cursor-pointer text-black-600 mx-2">
            arrow_back_ios
          </span>
        </button>
        <button onClick={handleNextMonth}>
          <span className="material-icons-outlined cursor-pointer text-black-600 mx-2">
            arrow_forward_ios
          </span>
        </button>
        <h2 className="ml-4 text-xl text-black-500 font-bold">
          {dayjs(new Date(dayjs().year(), monthIndex)).format("MMMM YYYY")}
        </h2>
      </div>
      <div>
        <button onClick={handleChangeToMonth} className="border rounded py-2 px-4 mr-5">
          Month
        </button>
        <button onClick={handleChangeToWeek} className="border rounded py-2 px-4 mr-5">
          Week
        </button>
      </div>
    </header>
  );
}
